import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const fetchBlog = () => api.get("/blog").then((r) => r.data);
export const fetchPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);

export const adminLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);

export const verifyToken = (token) =>
  api.get("/auth/me", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const fetchMessages = (token) =>
  api.get("/contact", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
